/* Banky Nieuw WP1.4: gedrag van de snelkooplade op productkaarten (Keuzebord #15, principes-audit C13).
   Geladen door snippets/banky-card-body.liquid bij kaarten met een snelkooplade (meerdere varianten); het script draait
   één keer per pagina, ook als meerdere kaarten het laden. Werkt met Halo's eigen formulier en gebeurtenissen:
     - Direct afrekenen (snippets/banky-direct-checkout.liquid): de knop verzendt Halo's productformulier; Halo voegt het
       product toe zoals altijd (variant:add) en daarna gaat de pagina naar /checkout in plaats van de lade te openen.
       Bij een fout van Shopify (cart:error) blijft de lade open met Halo's melding.
     - Variantwissel in de lade (variant:change): het tintlabel "Bespaar x%" (price-list, naar beneden afgerond), de
       leverregel (niet bij een uitverkochte variant) en Direct afrekenen volgen de gekozen variant.
     - Toevoegen vanuit de snelkooplade (eindronde collectie, 01-10-2026): dezelfde lade als de "+" op een kaart en de
       koopknop op de productpagina. Halo's QuickBuyDrawer blokkeert bij variant:add de lade en toont in de snelkooplade
       zijn eigen melding (sections/variant-added.liquid, zonder "Maak het compleet"). Daarom wordt variant:add van een
       formulier in een snelkooplade hier in de vangfase gestopt en vanaf het document opnieuw verstuurd met dezelfde
       gegevens: de snelkooplade sluit (met het formulier nog geladen) en Halo's CartDrawer opent de lade; cart:change
       ververst die zoals altijd. Alle andere luisteraars van variant:add zitten op het document en krijgen het event dus
       nog steeds één keer.
     - Snelkooplade (WP r1-zoek-kar): alleen de sectie banky-snelkoop ophalen in plaats van de hele productpagina.
     - "Zet me op de lijst" in de snelkooplade (toets voorraadmail 06-10-2026): de lade heeft geen formulier "Houd me op de
       hoogte" en Halo voert de scripts in de lade niet uit, dus de knop deed niets. Hij opent nu de productpagina op de
       gekozen variant met #banky-bis-terugval; banky-product.js (bisTerugval) opent daar het formulier meteen, alleen bij een
       uitverkochte variant. Dit script laadt ook op de productpagina (main-product), dus daar werkt de lade hetzelfde. */
(() => {
  if (window.bankyCards) return;
  window.bankyCards = {versie: 1};

  const wortel = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const formVan = el => (el instanceof HTMLFormElement ? el : el && el.closest ? el.closest('form') : null);
  // Het id via getAttribute: in Halo's productformulier heet een veld "id", dus form.id is dat veld en niet het id.
  const formId = form => form.getAttribute('id') || '';
  const perForm = (selector, form) => document.querySelectorAll(selector.replace('%', CSS.escape(formId(form))));

  // Direct afrekenen: onthouden welke knop het formulier verzond (vangfase, dus vóór Halo's eigen verwerking).
  document.addEventListener('submit', e => {
    const form = formVan(e.target);
    if (!form) return;
    if (e.submitter && e.submitter.matches('[data-banky-direct-checkout]')) form.dataset.bankyDirect = '1';
    else delete form.dataset.bankyDirect;
  }, true);

  document.addEventListener('variant:add', e => {
    const form = formVan(e.target);
    if (!form) return;
    if (form.dataset.bankyDirect === '1') {
      delete form.dataset.bankyDirect;
      if (e.detail) e.detail.blockCartDrawerOpening = true;
      window.location.assign(wortel().replace(/\/?$/, '/') + 'checkout');
      return;
    }
    const snelkoop = form.closest('quick-buy-drawer');
    if (!snelkoop || (e.detail && e.detail.blockCartDrawerOpening)) return;
    e.stopPropagation();
    if (typeof snelkoop.hide === 'function') snelkoop.hide();
    document.documentElement.dispatchEvent(new CustomEvent('variant:add', {bubbles: true, detail: e.detail}));
  }, true);

  document.addEventListener('cart:error', e => {
    const form = formVan(e.target);
    if (form) delete form.dataset.bankyDirect;
  }, true);

  // Variantwissel: besparing, leverregel en Direct afrekenen per gekozen variant.
  document.addEventListener('variant:change', e => {
    const form = formVan(e.target);
    const variant = e.detail && e.detail.variant;
    if (!form || !formId(form) || !variant) return;
    const beschikbaar = !!variant.available;
    const procent = variant.compare_at_price > variant.price ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
    perForm('[data-banky-besparing="%"]', form).forEach(label => {
      label.hidden = !procent;
      if (procent && label.dataset.sjabloon) label.textContent = label.dataset.sjabloon.replace('{pct}', procent + '%');
    });
    // Bundel (BESLUITEN §18): de van-prijs en "Bespaar" van een bundel gelden alleen voor de variant waarvoor ze zijn uitgerekend.
    perForm('[data-banky-bundel="%"]', form).forEach(el => { el.hidden = String(variant.id) !== el.dataset.variant; });
    perForm('[data-banky-direct-checkout][form="%"]', form).forEach(knop => { knop.disabled = !beschikbaar; });
    perForm('.banky-quick-buy[data-banky-form="%"]', form).forEach(voet => {
      voet.querySelectorAll('[data-banky-delivery]').forEach(regel => {
        regel.dataset.beschikbaar = beschikbaar ? 'true' : 'false';
        regel.hidden = !beschikbaar;
      });
      if (beschikbaar && typeof window.bankyDelivery === 'function') window.bankyDelivery(voet);
    });
  });

  // Snelkooplade via section rendering (WP r1-zoek-kar, Geert 16-10 punt 18): Halo haalt bij de eerste opening de hele
  // productpagina op (circa 420 kB HTML) voor alleen de template quick-buy-content. Hier eerst (vangfase, vóór Halo's
  // klikluisteraar op body) alleen de sectie sections/banky-snelkoop.liquid; daarna opent Halo de lade zoals altijd
  // (_hasLoaded staat dan op true, dus Halo haalt niets meer op). Lukt het niet, dan doet Halo zijn eigen verzoek.
  document.addEventListener('click', e => {
    const knop = e.target.closest && e.target.closest('[aria-controls^="quick-buy-"]');
    const lade = knop && document.getElementById(knop.getAttribute('aria-controls'));
    if (!lade || lade.tagName !== 'QUICK-BUY-DRAWER' || lade._hasLoaded || lade.open || !lade.getAttribute('handle')) return;
    e.preventDefault();
    e.stopPropagation();
    if (lade._bankyLaden) return;
    lade._bankyLaden = true;
    const bediening = [lade, ...document.querySelectorAll(`[aria-controls="${CSS.escape(lade.id)}"]`)];
    bediening.forEach(el => el.setAttribute('aria-busy', 'true'));
    const url = wortel().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(lade.getAttribute('handle')) + '?section_id=banky-snelkoop';
    fetch(url, {headers: {Accept: 'text/html'}})
      .then(r => (r.ok ? r.text() : Promise.reject(new Error('status ' + r.status))))
      .then(html => {
        const tpl = new DOMParser().parseFromString(html, 'text/html').getElementById('quick-buy-content');
        if (!tpl) return;
        const inhoud = tpl.content;
        inhoud.querySelectorAll('noscript').forEach(n => n.remove());
        lade.replaceChildren(inhoud);
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
        lade._hasLoaded = true;
      })
      .catch(() => {})
      .finally(() => {
        bediening.forEach(el => el.setAttribute('aria-busy', 'false'));
        lade._bankyLaden = false;
        if (typeof lade.show === 'function') lade.show();
      });
  }, true);

  // Zet me op de lijst in de snelkooplade: naar de productpagina met de gekozen variant (het id-veld van het formulier in de lade).
  document.addEventListener('click', e => {
    const knop = e.target.closest && e.target.closest('quick-buy-drawer [data-banky-bis-open]');
    const lade = knop && knop.closest('quick-buy-drawer');
    const handle = lade && lade.getAttribute('handle');
    if (!handle) return;
    e.preventDefault();
    const id = (lade.querySelector('form [name="id"]') || {}).value || '';
    const url = new URL(wortel().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle), location.href);
    if (/^\d+$/.test(id)) url.searchParams.set('variant', id);
    url.hash = 'banky-bis-terugval';
    window.location.assign(url.href);
  });
})();
